$(function () {

  const targetNode = document.body;
  const observer = new MutationObserver(function (mutationsList) {
    if (document.querySelector('#product-recommendations .swiper')) {
      observer.disconnect(); // 一度で終わるなら切る
      const mySwiper2 = new Swiper('#product-recommendations .swiper', {
          slidesPerView: "auto",
          grabCursor: true,
      	navigation: {
      		nextEl: '#product-recommendations .swiper-button-next',
      		prevEl: '#product-recommendations .swiper-button-prev'
      	},
      	breakpoints: { //ブレークポイント
      		767: {
      		slidesPerView: 6
      		}
      	}
       });
    }
  });
  
  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  });  

});